import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function KeysPage() {
  return (
    <Box p={3}>
      <Typography variant="h3" gutterBottom>
        Keys
      </Typography>

      <Paper sx={{ p: 3 }}>
        <Typography>
          Key management page placeholder. Your existing key workflow can be wired back in next.
        </Typography>
      </Paper>
    </Box>
  );
}